import { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { RejectOrderConfirmModal } from "./RejectOrderConfirmModal";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { DeleteButton } from "../../../../components/NewButtons";

export type RejectOrderForm = {
  reason: string;
};

const rejectSchema = yup.object().shape({
  reason: yup
    .string()
    .required("Please enter reason for rejection to continue"),
});

export const RejectOrderSelector = () => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const methods = useForm<RejectOrderForm>({
    resolver: yupResolver(rejectSchema),
    defaultValues: {
      reason: "Too busy",
    },
  });

  const openModal = () => {
    setModalOpen(true);
    methods.reset();
  };

  return (
    <>
      <DeleteButton width="fit-content" onClick={openModal} type="button">
        Reject Order
      </DeleteButton>
      <FormProvider {...methods}>
        <RejectOrderConfirmModal
          isOpen={modalOpen}
          closeModal={() => setModalOpen(false)}
        />
      </FormProvider>
    </>
  );
};
